import { SalesforceFileTypes, SalesforceListTypes, SalesforceNamespace } from 'datasource-service-lib';
import { IFileDataSourceApiService, IIconService } from 'interfaces-lib';
import { IWorkflowService } from 'interfaces-lib';
import { INamedEntityService } from 'named-entity-service-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IFileListViewConfig } from '../../file-list-view/file-list-view.component';
import { IFileListProvider } from '../../interfaces/ifilelistprovider';
import { OkLocalFileChecker } from '../../interfaces/localfilechecker';
import { ServiceProviderService } from '../service.provider.service';
import { SalesforceFileToPathConverter } from './salesforce.filetopathconverter';

export class SalesforceFileListViewConfig implements IFileListViewConfig {
  readonly namespace = SalesforceNamespace.name;
  readonly fileDataSourceApiService: IFileDataSourceApiService;
  readonly workflowService: IWorkflowService;
  readonly namedEntityService: INamedEntityService;
  readonly iconService: IIconService;
  readonly fileToPathConverter = new SalesforceFileToPathConverter(SalesforceListTypes.FileAttachments);

  readonly localFileChecker = OkLocalFileChecker;
  readonly fileListProvider: IFileListProvider;

  // @TODO: work on salesforce files
  constructor(serviceProviderService: ServiceProviderService, sharedServiceProviderServiceFactory: SharedServiceProviderServiceFactory) {
    const dataSourceApiService = serviceProviderService.getDataSourceApiService(SalesforceNamespace.name);
    this.fileListProvider = {
      dataSourceApiService: dataSourceApiService,
      listType: SalesforceListTypes.FileAttachments,
      fileType: SalesforceFileTypes.FileAttachment,
    };
    this.fileDataSourceApiService = sharedServiceProviderServiceFactory.getServiceProviderService(SalesforceNamespace.name).getFileDataSourceApiService();
    this.workflowService = serviceProviderService.getWorkflowService(SalesforceNamespace.name);
    this.namedEntityService = sharedServiceProviderServiceFactory
      .getServiceProviderService(SalesforceNamespace.name)
      .getNamedEntityService();
    this.iconService = serviceProviderService.getIconService(SalesforceNamespace.name);
  }
}
